// extracted by mini-css-extract-plugin
module.exports = {"getStartedButton":"GetStartedButton_getStartedButton__hCcjY"};